var _circle, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaleAvater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 48.5,
    r: 48.5,
    fill: "#DEE2FD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_515_20323",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 97,
    height: 97
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 48.5,
    r: 48.5,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_515_20323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.5342 94.0552C79.5342 82.1083 69.8494 72.4235 57.9026 72.4235H38.8087C26.8619 72.4235 17.1771 82.1083 17.1771 94.0552V102.644C26.1918 108.376 36.8813 111.71 48.3557 111.71C59.8301 111.71 70.5195 108.376 79.5342 102.644V94.0552Z",
    fill: "#4D60C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3131 64.1397V70.478C55.3131 74.6625 52.2293 78.0547 48.4252 78.0547H48.2861C44.482 78.0547 41.3982 74.6625 41.3982 70.478V64.1397",
    fill: "#F8D19F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3982 68.6963C43.4891 69.5999 45.7751 70.1059 48.1753 70.1059H48.5361C50.9363 70.1059 53.2223 69.5999 55.3131 68.6963V65.8223H41.3982V68.6963Z",
    fill: "#F5BC8E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7447 43.5961C28.3711 43.5961 27.885 43.2003 27.6646 42.7164C27.4063 42.1495 27.3187 39.5434 27.4184 35.3861C27.5528 29.7736 27.6831 28.6546 28.4208 26.7738C28.8872 25.5848 30.0455 23.5871 30.9948 22.3342C32.1007 20.8747 33.7352 19.3679 35.5444 18.1399C37.0973 17.0859 39.3521 15.8412 40.555 15.374C42.3154 14.6902 43.75 14.5158 46.7376 14.518C48.7789 14.5195 51.9078 15.2045 54.6636 15.26C58.3798 15.3348 59.8325 14.5272 60.743 15.26C61.3325 16 60.8325 18.1399 60.8325 19.5C61.8325 21 61.1523 19.9537 63.8676 22.6081C65.9357 24.6297 66.9233 25.9655 68.0112 28.2124C69.4224 31.1272 69.4413 31.2243 69.5894 36.3437C69.6718 39.1934 69.5908 41.9492 69.4092 42.4678C69.2277 42.9863 68.7472 43.4586 68.3416 43.5173C67.9359 43.5761 67.2835 43.3898 66.8917 43.1033C66.3613 42.7155 66.1366 41.9914 66.012 40.2686C65.8447 37.9549 65.8447 37.9549 63.325 35.8964C61.9391 34.7643 60.2981 33.5168 59.6783 33.1244C58.5513 32.4108 58.5513 32.4108 57.2238 34.2585C56.4938 35.2747 55.2168 36.7201 54.3862 37.4706C53.5555 38.221 51.7146 39.3916 50.2952 40.0718C48.8758 40.752 46.588 41.4986 45.2112 41.7308C43.1668 42.0756 42.2009 42.0486 39.9413 41.5831C38.4196 41.2696 35.973 40.407 34.5043 39.6661C33.0356 38.9252 31.6994 38.3322 31.535 38.3483C31.3707 38.3644 31.1298 39.3314 30.9998 40.4972C30.8423 41.9091 30.5398 42.7803 30.0937 43.1065C29.7254 43.3758 29.1184 43.5961 28.7447 43.5961Z",
    fill: "#252546"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.643 48.1816H30.7304C33.1213 48.1816 35.0595 46.2434 35.0595 43.8525V43.7651C35.0595 41.3742 33.1213 39.436 30.7304 39.436H30.643C28.2521 39.436 26.3139 41.3742 26.3139 43.7651V43.8525C26.3139 46.2434 28.2521 48.1816 30.643 48.1816ZM65.9808 48.1816H66.0683C68.4592 48.1816 70.3974 46.2434 70.3974 43.8525V43.7651C70.3974 41.3742 68.4592 39.436 66.0683 39.436H65.9808C63.59 39.436 61.6518 41.3742 61.6518 43.7651V43.8525C61.6518 46.2434 63.59 48.1816 65.9808 48.1816Z",
    fill: "#F5BD8E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3109 42.8902L30.3109 48.5986C30.3109 58.9832 38.309 67.4016 48.1752 67.4016H48.5361C58.4023 67.4016 66.4004 58.9832 66.4004 48.5986V42.5172C66.4004 42.4985 66.4004 42.4798 66.4003 42.4612C66.202 42.0031 66.0883 41.3229 66.012 40.2686C65.9405 39.2798 65.8995 38.7136 65.6794 38.2287C65.3845 37.5789 64.7679 37.0752 63.325 35.8964C61.9391 34.7643 60.2981 33.5168 59.6783 33.1244C58.5513 32.4108 58.5513 32.4108 57.2238 34.2585C56.4938 35.2747 55.2168 36.7201 54.3862 37.4706C53.5555 38.221 51.7146 39.3916 50.2952 40.0718C48.8758 40.752 46.588 41.4985 45.2112 41.7308C43.1668 42.0756 42.2009 42.0486 39.9413 41.5831C38.4196 41.2696 35.973 40.407 34.5043 39.6661C33.0356 38.9252 31.6994 38.3322 31.535 38.3483C31.3707 38.3644 31.1298 39.3314 30.9998 40.4972C30.8694 41.6666 30.6394 42.465 30.3109 42.8902Z",
    fill: "#F8D19F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.8794,
    cy: 46.3846,
    rx: 2.36347,
    ry: 2.36346,
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.7092,
    cy: 46.3846,
    rx: 2.36346,
    ry: 2.36346,
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3873 61.3383H48.3093C46.1753 61.3383 44.4454 59.6084 44.4454 57.4744V57.4354H52.2512V57.4744C52.2512 59.6084 50.5213 61.3383 48.3873 61.3383Z",
    fill: "#F3B28E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaleAvater);
export default __webpack_public_path__ + "static/media/male_avater.81a7a741ae4daff6f8e374c603a92fd1.svg";
export { ForwardRef as ReactComponent };